import api from "../../../utils/authFetch";

export const getUserProfile = async (userId) => {
    const response = await api.get(`${process.env.REACT_APP_BACKEND_URL}/ai-service/user-profile?user_id=${userId}`);
    const data = response.data;
    return data;
};


export const updateUserProfile = async (data) => {
    const response = await api.patch(`${process.env.REACT_APP_BACKEND_URL}/ai-service/user-profile`, data);
    return response.data;
};